import dataBusReducer from './dataBus.reducer';

export const combinedReducers = {
    dataBus: dataBusReducer,
};
